/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchStripePublishableKey2QueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchStripePublishableKey2Query = { __typename?: 'Query', stripePublishableKey?: string | null };

export type CreateSessionForSubscriptionPaymentMutationVariables = Types.Exact<{
  lineItem: Types.StripeSessionLineItemInput;
}>;


export type CreateSessionForSubscriptionPaymentMutation = { __typename?: 'Mutation', createSessionForSubscriptionPayment?: { __typename?: 'StripeCreateSessionResult', clientSecret: string } | null };


export const FetchStripePublishableKey2Document = gql`
    query fetchStripePublishableKey2 {
  stripePublishableKey
}
    `;

/**
 * __useFetchStripePublishableKey2Query__
 *
 * To run a query within a React component, call `useFetchStripePublishableKey2Query` and pass it any options that fit your needs.
 * When your component renders, `useFetchStripePublishableKey2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchStripePublishableKey2Query({
 *   variables: {
 *   },
 * });
 */
export function useFetchStripePublishableKey2Query(baseOptions?: Apollo.QueryHookOptions<FetchStripePublishableKey2Query, FetchStripePublishableKey2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchStripePublishableKey2Query, FetchStripePublishableKey2QueryVariables>(FetchStripePublishableKey2Document, options);
      }
export function useFetchStripePublishableKey2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchStripePublishableKey2Query, FetchStripePublishableKey2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchStripePublishableKey2Query, FetchStripePublishableKey2QueryVariables>(FetchStripePublishableKey2Document, options);
        }
export function useFetchStripePublishableKey2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchStripePublishableKey2Query, FetchStripePublishableKey2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchStripePublishableKey2Query, FetchStripePublishableKey2QueryVariables>(FetchStripePublishableKey2Document, options);
        }
export type FetchStripePublishableKey2QueryHookResult = ReturnType<typeof useFetchStripePublishableKey2Query>;
export type FetchStripePublishableKey2LazyQueryHookResult = ReturnType<typeof useFetchStripePublishableKey2LazyQuery>;
export type FetchStripePublishableKey2SuspenseQueryHookResult = ReturnType<typeof useFetchStripePublishableKey2SuspenseQuery>;
export type FetchStripePublishableKey2QueryResult = Apollo.QueryResult<FetchStripePublishableKey2Query, FetchStripePublishableKey2QueryVariables>;
export const CreateSessionForSubscriptionPaymentDocument = gql`
    mutation createSessionForSubscriptionPayment($lineItem: StripeSessionLineItemInput!) {
  createSessionForSubscriptionPayment(lineItem: $lineItem) {
    clientSecret
  }
}
    `;
export type CreateSessionForSubscriptionPaymentMutationFn = Apollo.MutationFunction<CreateSessionForSubscriptionPaymentMutation, CreateSessionForSubscriptionPaymentMutationVariables>;

/**
 * __useCreateSessionForSubscriptionPaymentMutation__
 *
 * To run a mutation, you first call `useCreateSessionForSubscriptionPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionForSubscriptionPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionForSubscriptionPaymentMutation, { data, loading, error }] = useCreateSessionForSubscriptionPaymentMutation({
 *   variables: {
 *      lineItem: // value for 'lineItem'
 *   },
 * });
 */
export function useCreateSessionForSubscriptionPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionForSubscriptionPaymentMutation, CreateSessionForSubscriptionPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionForSubscriptionPaymentMutation, CreateSessionForSubscriptionPaymentMutationVariables>(CreateSessionForSubscriptionPaymentDocument, options);
      }
export type CreateSessionForSubscriptionPaymentMutationHookResult = ReturnType<typeof useCreateSessionForSubscriptionPaymentMutation>;
export type CreateSessionForSubscriptionPaymentMutationResult = Apollo.MutationResult<CreateSessionForSubscriptionPaymentMutation>;
export type CreateSessionForSubscriptionPaymentMutationOptions = Apollo.BaseMutationOptions<CreateSessionForSubscriptionPaymentMutation, CreateSessionForSubscriptionPaymentMutationVariables>;